import { ErrorStateMatcher } from "@angular/material/core";
import { FormControl, FormGroupDirective, NgForm } from "@angular/forms";

export class ShowOnSubmitAttemptErrorStateMatcher implements ErrorStateMatcher {
  submitAttempted = false;

  isErrorState(
    control: FormControl | null,
    _form: FormGroupDirective | NgForm | null,
  ): boolean {
    return this.submitAttempted && Boolean(control?.invalid);
  }
}
